import { FastRepliesHotKey, hotKeyEmpty, HotKeyValues } from "../../../models/fastRepliesHotKeys"
import keycode from "keycode"
import { RUSSIAN_KEYS } from "../../HotKeysExtensionForm/HotKeysExtensionForm.const"

export const keyToWord = (key?: number): string => {
    let secondKey = key ? keycode(key) : ""
    if (!secondKey && key) {
        secondKey = RUSSIAN_KEYS[key]
    }
    
    return secondKey
}

export const toHotKeyValues = (hotKey?: FastRepliesHotKey): HotKeyValues => {
    return hotKey
        ? {
              FirstKey: keycode(hotKey.FirstKey).toUpperCase(),
              SecondKey: keyToWord(hotKey?.SecondKey).toUpperCase()
          }
        : hotKeyEmpty
}
